<template>
  <BaseDialog :value="true" max-width="700" persistent>
    <template #modal>
      <BaseCosmoCard>
        <template #title>
          <div class="modal_header">
            <BaseTitle
              class="modal_header_title"
              v-text="$t('folder.yousign.relaunchMessage')"
            />
            <BaseButtonIcon icon="$mdiClose" @click="$emit('close')" />
          </div>
        </template>
        <template v-if="loading">
          <div class="modal_content" v-text="`${$t('utils.loading')}...`" />
        </template>
        <template v-else-if="results && results.contactCount">
          <div class="modal_content">
            <div class="descriptor">
              {{
                $t("workflow.status.relanchContactAndFolder", {
                  folder: results.folderCount,
                  contact: results.contactCount,
                })
              }}
            </div>
            <div v-if="affectableStatus.length">
              <div
                class="label-input"
                v-text="
                  $t('utils.fromStatusTo', {
                    statusName: wfStatuses.find(
                      (wfStat) => wfStat.id === statusId
                    ).name,
                  })
                "
              />

              <base-autocomplete
                v-model="statusTarget"
                :items="affectableStatus"
                :placeholder="$t('automation.dialog.choose_status')"
                outlined
                item-text="name"
                item-value="id"
                :disabled="isSubmiting"
                solo
                clearable
              />
            </div>
            <BaseMarkdownEditor
              v-model="description"
              :label="$t('organization.formDescription')"
            />
          </div>

          <div class="modal_footer">
            <BaseButton color="grey" type="secondary" @click="$emit('close')">
              {{ $t("utils.cancel") }}
            </BaseButton>
            <BaseButton
              :loading="isSubmiting"
              :disabled="isSubmiting"
              @click="submit()"
            >
              {{ $t("utils.validate") }}
            </BaseButton>
          </div>
        </template>
        <template v-else>
          <div class="modal_content">
            <div class="descriptor">
              {{ $t("workflow.status.errorMessageFromCount") }}
            </div>
          </div>
        </template>
      </BaseCosmoCard>
    </template>
  </BaseDialog>
</template>

<script>
import {
  getOrganizationWorkflowStatusUsage,
  postOrganizationWorkflowStatusReminder,
} from "../../Services/workflow.service";

export default {
  name: "WorkflowFolderRelauncDialog",
  props: {
    statusId: {
      type: Number,
      required: true,
    },
    wfStatuses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isSubmiting: false,
      loading: true,
      results: null,
      description: "",
      statusTarget: undefined,
    };
  },
  computed: {
    affectableStatus() {
      if (!this.wfStatuses.length) return [];
      return this.wfStatuses.filter((wfStat) => wfStat.id !== this.statusId);
    },
  },
  created() {
    this.getFolderCountToRelaunch();
  },
  methods: {
    async getFolderCountToRelaunch() {
      this.loading = true;
      try {
        this.results = (
          await getOrganizationWorkflowStatusUsage({
            organizationId: this.$route.params.organizationId,
            workflowId: this.$route.params.workflowId,
            statusId: this.statusId,
          })
        )?.data;
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.loading = false;
    },
    async submit() {
      this.isSubmiting = true;
      try {
        await postOrganizationWorkflowStatusReminder({
          organizationId: this.$route.params.organizationId,
          workflowId: this.$route.params.workflowId,
          statusId: this.statusId,
          payload: { message: this.description, status: this.statusTarget },
        });

        if (this.statusTarget) {
          this.$store.dispatch("snackbar/active", {
            message: this.$t(
              "workflow.status.snackbar.success.relaunchInProgress"
            ),
            type: "LOADING",
            timeout: 2000,
          });
        } else {
          this.$store.dispatch("snackbar/active", {
            message: this.$t(
              "workflow.status.snackbar.success.relaunchedSuccessfully"
            ),
            type: "SUCCESS",
          });
        }
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("cosmoform.relaunchError"),
          type: "ERROR",
        });
      }

      if (this.statusTarget) {
        return setTimeout(() => {
          this.isSubmiting = false;
          this.$emit("reloadStatusFolder");
          this.$emit("close");
        }, 2000);
      }
      this.isSubmiting = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 16px;
  flex-wrap: wrap;
  .modal_header_title {
    flex: 1;
  }
}
.modal_content {
  padding: 24px 10px;

  & > * {
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .label-input {
    font-size: 12px;
  }
  .descriptor {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #353542;
  }
}
.modal_footer {
  width: 100%;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  & > * {
    margin-left: 16px;
  }
}
</style>
